module.exports = __webpack_public_path__ + "assets/img/1.744e0a4b.jpg";